import __base_store from '@/store/__base_store'

/**
 * Store de conceptos de movimiento de caja (modelo `concepto_movimiento_caja`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'concepto_movimiento_caja',
	},
})

